// Feature flags per abilitare/disabilitare sezioni dell'app.
// EVENTS_ENABLED: la sezione Eventi è nascosta finché non ci saranno eventi
// da mostrare. Riportare a `true` per riattivarla (footer, card home e route).
const EVENTS_ENABLED = false

export { EVENTS_ENABLED }
